import { useOutlet } from 'react-router';
import { useAuthContext } from '../context';
import { Spinner } from '@lib/ui';

function LoadingScreen() {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-gray-50 dark:bg-dark-900">
      <div className="flex flex-col items-center gap-4">
        <Spinner size="md" />
        <p className="text-sm text-gray-500 dark:text-dark-300">Loading...</p>
      </div>
    </div>
  );
}

export default function AuthGuard() {
  const outlet = useOutlet();
  const { isAuthenticated, isLoading, login } = useAuthContext();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    login();
    return <LoadingScreen />;
  }

  return <>{outlet}</>;
}
